export default __webpack_public_path__ + "static/media/arrow.4a7bf3c2.svg";